import { render, staticRenderFns } from "./EnrollmentList.vue?vue&type=template&id=4d64f628&"
import script from "./EnrollmentList.vue?vue&type=script&lang=js&"
export * from "./EnrollmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports